module.exports = "pegasus/assets/lp/travel/bg0.png";